export default __webpack_public_path__ + "static/media/Transport_bg.237d0e41.jpg";